import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/` — redirects to `/dashboard`.
 *
 * Matches the vanilla site's behavior: hitting the root sends you to the
 * dashboard (or to /login if you're unauthenticated — handled later by
 * the _authed guard when we wire useAuth).
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' });
  },
});
